import { makeStyles } from "tss-react/mui"
import { DialogContent } from "@mui/material"
import { StandardDialog } from "../../../../dialogs/StandardDialog"
import {
    AttendeeDetails,
    CreateUpdateAttendeesFormValues,
} from "../../../../dialogs/createUpdateBookingDialog/attendees/attendeesForm/attendeesTypes"
import { CreateUpdateAttendeesForm } from "../../../../dialogs/createUpdateBookingDialog/attendees/attendeesForm/CreateUpdateAttendeesForm"
import { useAppLocalization } from "../../../../../../modules/localization/components/AppLocalizationProvider"
import { FieldsParams } from "../../form/formTypes"

const useStyles = makeStyles()((theme) => ({
    dialogContent: {
        padding: "3rem",
        paddingTop: ".5rem",
        display: "flex",
        gap: "3rem",
        flexDirection: "column",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            padding: ".5rem 1rem 1.5rem",
        },
    },
}))

type CreateOrderDialogParticipantsProps = Readonly<{
    open: boolean
    onClose: () => void
    participantsList: AttendeeDetails[]
    handleChangeParticipants: (val: AttendeeDetails[]) => void
    fieldsParams?: FieldsParams[]
}>

export function CreateOrderDialogParticipants({
    open,
    onClose,
    participantsList,
    handleChangeParticipants,
    fieldsParams,
}: CreateOrderDialogParticipantsProps) {
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()

    const handleChangeAttendees = (attendeesList: CreateUpdateAttendeesFormValues) => {
        handleChangeParticipants(attendeesList.attendees)
    }

    return (
        <StandardDialog
            dialogTitle={l10n.getString("create-order-attendees-dialog-title")}
            open={open}
            onClose={onClose}
            maxWidthProp="lg"
            scroll="body"
        >
            <DialogContent className={classes.dialogContent}>
                <CreateUpdateAttendeesForm
                    initialValues={{ attendees: participantsList }}
                    handleChangeAttendees={handleChangeAttendees}
                    submitButtonText={l10n.getString("create-order-attendees-dialog-submit-button")}
                    fieldsParams={fieldsParams}
                />
            </DialogContent>
        </StandardDialog>
    )
}
